<ul class="list">
  <li v-for="address in enrichedAddresses" :key="address.id" :class="{active: selectedAddressId === address.id}">
    <div class="item-wrapper">
      <div class="tick" @click="handleSelect(address)">
        <span class="iconfont-check" v-if="selectedAddressId === address.id"></span>
      </div>
      <div class="item-holder" @click="handleSelect(address)">
        <div class="item-content">
          <div v-if="address.station_deliver === 'station'" class="station-title">{{ $t('address.dhl_station') }}</div>
          <div>{{ getGenderLabel(address.gender) }} {{ address.firstname }} {{ address.lastname }}</div>
          <div v-if="address.station_deliver === 'station'">{{ address.packstation }}, {{ address.postnumber }}</div>
        <div v-if="address.station_deliver !== 'station'">{{ address.company }} {{ address.address_details }}</div>
        <div v-if="address.station_deliver !== 'station'">{{ address.address }} {{ address.house_number }}</div>
          <div>{{ address.zip }} {{ address.city }}, {{ address.countryName }}</div>
        </div>
        <div class="icon" @click.stop="goToEdit(address.id)">
          <span class="iconfont-arrow-right"></span>
        </div>
      </div>
    </div>
    <div class="error" v-if="address.is_invalid">{{ $t('shopping.errors.invalid_address') }}</div>
  </li>
</ul>
